<template>
  <!--begin::Table-->
  <div class="table-responsive">
    <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
      <tbody>
        <template v-for="(row, i) in lineHistory">
          <tr v-bind:key="i">
            <!-- <td style="min-width: 80px">28/11/2020</td> -->
            <td v-if="row.note === 'inspected to Survey'" style="min-width: 100px">
              Inspected on <b>{{ row.date }}</b> by <b>{{ row.userName }}</b>
            </td>
            <td v-else style="min-width: 100px">
              <span v-if="row.currentStatus === 'unknown'">{{ row.date }} : The Status for the <b>{{ row.sparePart }}</b> was changed into </span>
              <span v-else >{{ row.date }} : The Status for the <b>{{ row.sparePart }}</b> was changed from <b>{{ row.currentStatus}}</b> into </span>
              
              <span v-if="row.newStatus === 'green'" class="label label-lg label-inline label-light-success">
                <span class="label-light-success label-inline font-weight-bold">{{ row.newStatus }}</span>
              </span>
              <span v-if="row.newStatus === 'orange'" class="label label-lg label-inline label-light-warning">
                <span class="label-light-success label-inline font-weight-bold">{{ row.newStatus }}</span>
              </span>
              <span v-if="row.newStatus === 'red'" class="label label-lg label-inline label-light-danger">
                <span class="label-light-success label-inline font-weight-bold">{{ row.newStatus }}</span>
              </span>
              by <b>{{ row.userName }}</b>
              <br><span v-if="row.note != 'null'" class="text-muted font-size-sm">Extra info :</span><span
                v-if="row.note != 'null'" class="text-muted font-weight-bold font-size-sm">"{{ row.note }}"</span>
              <div v-if="row.imagePath != ''" class="symbol symbol-50 symbol-light mr-2">
                <span class="symbol-label">
                  <b-img class="h-50 align-self-center" fluid @click="open(row.imagePath)" v-b-modal.modal-1
                    v-bind:src="'media/' + row.imagePath" alt="Image 1"></b-img>
                </span>
              </div>
            </td>
            <!-- <b-button @click="editMaintanace(row.id)" pill>Edit</b-button> -->
          </tr>
        </template>
      </tbody>
    </table>
    <div>
      <b-modal id="modal-1">
        <b-img fluid v-bind:src="'media/' + imagePath" alt="Image Big"></b-img>
      </b-modal>
    </div>
  </div>
  <!--end::Table-->
</template>

<script>
import JwtService from "@/core/services/jwt.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "widget-1",
  props: ['lineHistory', 'lineId', 'conveyorId'],
  data() {
    return {
      companyId: JwtService.authorizeToken().companyId,
      imagePath: ''
      // checked: false,
    };
  },
  methods: {
    open(imagePath) {
      this.imagePath = imagePath
    },
    editMaintanace(HistoryId) {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `Home > Line ${this.lineId} > Conveyor ${this.conveyorId} > Maintenance ${HistoryId}`,
          route: `/line/${this.lineId}/conveyor/${this.conveyorId}`,
          HistoryId: HistoryId,
        },

      ]);
      this.$router.push(
        "/line/" + this.lineId + "/conveyor/" + this.conveyorId + "/maintenance/" + HistoryId
      );
    },
  },
  components: {},

};
</script>
